import React, { PropsWithChildren } from "react";

const ReviewText = ({ children }: PropsWithChildren) => {
  return (
    <p className="mb-0 text-gray-800 text-base text-ellipsis">{children}</p>
  );
};

export default ReviewText;
